__turbopack_context__.v({
  "video-overlay-icon": "video-overlay-icon-module-scss-module__xIl_-a__video-overlay-icon",
});
